/**
 * Created by mh on 2017/5/23.
 */
import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observer } from 'mobx-react';

import DeliverMediaImageSchema from './3dschema.jpg';

@observer
class Dashboard extends Component {
    render() {
        return (
            <section>
                <h1>
                    <FormattedMessage
                        id="Home.Slogan"
                        defaultMessage="Connect. Automate. Deliver." />
                </h1>
                <nav className="navbar navbar-expand-md navbar-light bg-faded">
                    <button
                        className="navbar-toggler navbar-toggler-right"
                        type="button"
                        data-toggle="collapse"
                        data-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon" />
                    </button>
                </nav>
                <div className="row mt-5">
                    <div className="col-12">
                        <p>
                            <img
                                src={DeliverMediaImageSchema}
                                className="img-fluid mx-auto d-block"
                                alt="deliver.media" />
                        </p>
                    </div>
                </div>
            </section>
        );
    }
}

// Dashboard.wrappedComponent.propTypes = {
// };

export default injectIntl(Dashboard);
